import { getAppConfig } from "services/configService";
import { GET } from "services/httpService";
import urlJoin from "url-join";
import { OrderSources } from "./../application/order/orderConstants";

const apiUrl = () => {
  return getAppConfig().OrderApiUrl;
};

/*
There are 2 ways of referring to orders.
1 = SuperOrder -> Order -> OrderLines
OR
2 = Order -> Product -> CopyItem
We are converting the result form the API (1) to (2)
*/
const mapProduct = product => {
  return {
    ...product,
    orderCode: product.superOrderCode,
    superOrderCode: undefined
  };
};

const mapOrder = order => {
  return {
    ...order,
    products: order.orders.map(p => mapProduct(p)),
    productCount: order.orderCount,
    orderCount: undefined,
    orders: undefined,
    _orderSource: OrderSources.Albelli
  };
};

export const getOrdersMe = async (offset = 0, limit = 100) => {
  const response = await GET(
    { includeToken: true },
    urlJoin(apiUrl(), `/v2/superorders/me?Offset=${offset}&Limit=${limit}&OrderState=notExpired`)
  );

  return { ...response, items: response.items.map(o => mapOrder(o)) };
};

export const getOrderByCode = async orderCode => {
  const order = await GET({ includeToken: true }, urlJoin(apiUrl(), `/v1/superorders/${orderCode}`));
  return mapOrder(order);
};

export const getProductsByAccountId = async (requestInfo, accountId, articleNames, offset = 0, limit = 10) => {
  const response = await GET(
    requestInfo,
    urlJoin(
      apiUrl(),
      `/orders/byAccount/${accountId}?articleNames=${articleNames.toString()}&offset=${offset}&limit=${limit}`
    )
  );
  return { ...response, items: response.items.map(p => mapProduct(p)) };
};

export const getProductByCode = async (requestInfo, productCode) => {
  const product = await GET(requestInfo, urlJoin(apiUrl(), `/v1/Orders/${productCode}`));
  return mapProduct(product);
};
